export default __webpack_public_path__ + "static/media/ArianaGrande-LastChristmas.61a4fa19.mp3";